import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@design-system/components/typography/typography';

type Props = {
  membersCount: number;
};

export const CommunityToolbar = ({ membersCount }: Props) => (
  <div className="flex items-center gap-2 text-[#9E9E9E]">
    <FontAwesomeIcon icon={faUser} className="text-xs" />
    <Typography
      as="span"
      variant="body"
      size="small"
      fontWeight="normal"
      className="text-[#131313]"
    >
      {`${membersCount} members`}
    </Typography>
  </div>
);
